/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Collapse = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 -5 34 40">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 9C7.25 8.44772 7.69772 8 8.25 8C8.80228 8 9.25 8.44772 9.25 9V23C9.25 23.5523 8.80228 24 8.25 24C7.69772 24 7.25 23.5523 7.25 23V9ZM19.9571 9.29289C20.3476 9.68342 20.3476 10.3166 19.9571 10.7071L15.6642 15H25.75C26.3023 15 26.75 15.4477 26.75 16C26.75 16.5523 26.3023 17 25.75 17H15.6642L19.9571 21.2929C20.3476 21.6834 20.3476 22.3166 19.9571 22.7071C19.5666 23.0976 18.9334 23.0976 18.5429 22.7071L12.5429 16.7071C12.1524 16.3166 12.1524 15.6834 12.5429 15.2929L18.5429 9.29289C18.9334 8.90237 19.5666 8.90237 19.9571 9.29289Z"
      />
      <path d="M16 1C7.71573 1 1 7.71573 1 16H-1C-1 6.61116 6.61116 -1 16 -1V1ZM31 16C31 7.71573 24.2843 1 16 1V-1C25.3888 -1 33 6.61116 33 16H31ZM16 31C24.2843 31 31 24.2843 31 16H33C33 25.3888 25.3888 33 16 33V31ZM16 33C6.61116 33 -1 25.3888 -1 16H1C1 24.2843 7.71573 31 16 31V33Z" />
    </BaseSvgIcon>
  )
}

export default Collapse
